import React from 'react';
import { useTranslation } from 'react-i18next';
import { Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { label: 'Direct Hire', href: '#services' },
      { label: 'Executive Search', href: '#executive-search' },
      { label: 'Expert Design Consultants', href: '#services' },
      { label: 'Strategic Hiring Consultants', href: '#services' }
    ],
    expertise: [
      { label: 'Semiconductors', href: '#expertise' },
      { label: 'AI & Machine Learning', href: '#expertise' },
      { label: 'Power Electronics', href: '#expertise' },
      { label: 'Future Grid & Energy', href: '#expertise' }
    ],
    company: [
      { label: 'About Us', href: '#about' },
      { label: 'Testimonials', href: '#testimonials' },
      { label: 'Contact', href: '#contact' }
    ]
  };

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-white border-t border-gray-200 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-grid-pattern opacity-3" />
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Main Footer Content */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_neon-engineers/artifacts/dgstal0n_TAG%20LOGO.JPG" 
              alt="TAG Logo" 
              className="h-12 w-auto mb-4 filter brightness-110"
            />
            <p className="text-gray-600 leading-relaxed mb-6 max-w-sm">
              {t('footer.tagline')}
            </p>
            <div className="flex items-center space-x-4">
              <a 
                href="https://www.linkedin.com/company/tag-the-associates-group/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-50/50 border border-gray-200 rounded-lg flex items-center justify-center hover:bg-cyan-900/30 hover:border-cyan-500 transition-all duration-300 group"
              >
                <Linkedin className="w-5 h-5 text-gray-600 group-hover:text-cyan-700 transition-colors" />
              </a>
              <a 
                href="mailto:info@tag-jobs.com"
                className="w-10 h-10 bg-gray-50/50 border border-gray-200 rounded-lg flex items-center justify-center hover:bg-cyan-900/30 hover:border-cyan-500 transition-all duration-300 group"
              >
                <Mail className="w-5 h-5 text-gray-600 group-hover:text-cyan-700 transition-colors" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-gray-900 font-semibold mb-4">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={`service-${link.label}`}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-gray-600 hover:text-cyan-700 transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Expertise */}
          <div>
            <h4 className="text-gray-900 font-semibold mb-4">Expertise</h4>
            <ul className="space-y-3">
              {footerLinks.expertise.map((link) => (
                <li key={`expertise-${link.label}`}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-gray-600 hover:text-cyan-700 transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-gray-900 font-semibold mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={`company-${link.label}`}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-gray-600 hover:text-cyan-700 transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-gray-200">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <div className="text-sm text-gray-500">
              © {currentYear} TAG Technical Recruiting. {t('footer.rights')}
            </div>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-sm text-gray-500 hover:text-cyan-700 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-gray-500 hover:text-cyan-700 transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
